<template>
  <v-flex xs12 pt-0 mt-1>
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs12 py-0>
              <v-layout col wrap>
                <v-flex xs12 lg6 py-0><b>{{insertedDate(record)}} - {{insertedTime(record)}}</b></v-flex>
                <v-flex xs12 lg6 py-0>ID: <em>{{record.id}} (Origem: {{record.source}})</em></v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-0>
              <v-layout col wrap>
                <v-flex xs12 lg6 v-if="!isFromCreditCard">
                  <b>De:</b> Banco {{record.source_bank || 'N/A'}} - Agência {{record.source_branch || 'N/A'}} Conta {{record.source_account || 'N/A'}}
                </v-flex>
                <v-flex xs12 lg6 v-if="isFromCreditCard">Pagamento via Cartão de Crédito</v-flex>
                <v-flex xs12 lg6 v-if="record.scheduled_bank_transaction_id" >ID Transação: <em>{{record.scheduled_bank_transaction_id}}</em>
                  <span v-if="record.scheduled_bank_transaction && record.scheduled_bank_transaction.transaction_kind" style="color: red">
                    <span v-if="record.scheduled_bank_transaction.transaction_kind === 2">(Refund)</span>
                  </span>
                </v-flex>
                <v-flex xs12 lg6 v-if="!record.scheduled_bank_transaction_id" style="color: red">
                  <v-flex xs12 py-0>
                    Transação não identificada
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-0>
              <v-layout col wrap>
                <v-flex xs12 lg6><b>Para:</b> {{bankAccount}}</v-flex>
                <v-flex xs12 lg6><span v-if="record.company_wire_id">ID Transferência: <em>{{record.company_wire_id}}</em></span></v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-0>
              <v-layout col wrap>
                <v-flex xs12 lg6 py-0>
                  <b>{{l(record.value, record.currency)}}</b> <span v-if="isEstimatedValue">(estimado)</span>
                  <span v-if="record.exchange_id">convertidos para {{l(record.exchanged_value, record.exchange_currency)}} ({{record.exchange_rate}})</span>
                </v-flex>
                <v-flex xs12 lg6 align-right v-if="record.currency != record.exchange_currency">
                  <span v-if="record.iof_value > 0"> IOF: {{iof_value}} </span>
                  <span v-if="record.fx_value > 0"> FX: {{fx_value}} </span>
                  <span v-if="record.exchange_rate != 1">VET: {{record.exchange_rate}} </span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-0>
              <v-layout col wrap>
                <v-flex xs12 lg6>
                  <b>{{record.source_name || 'N/A'}}</b> - {{record.source_document_type.toUpperCase()}} {{mask(record.source_document_type, record.source_document_number)}}
                </v-flex>
                <span v-if="record.scheduled_bank_transaction">
                  <span v-if="record.scheduled_bank_transaction.transaction_kind === 2">
                    Parceiro: {{ companyName || '' }}
                  </span>
                  <span v-else-if="companyName">Parceiro: {{ companyName }}</span>
                </span>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-0 v-if="this.transactionCanceled" class="canceled">
              CANCELADA em {{transactionCanceledDate()}} - Motivo: {{record.scheduled_bank_transaction.canceled_reason}}
            </v-flex>
            <v-flex xs12 py-0>
              <v-layout col wrap>
                <v-flex xs12 lg6 v-if="record.spei_concepto_de_pago">Concepto: {{record.spei_concepto_de_pago}}</v-flex>
                <v-flex xs12 lg6 hide-if-mobile v-if="!record.spei_concepto_de_pago">&nbsp;</v-flex>
                <v-flex xs12 lg6 py-0 absolute-btn-parent top-0 left-0 v-if="!record.scheduled_bank_transaction_id">
                  <v-btn slot="btn" block dark class="ma-0 btn-style--secondary mt-3 absolute-btn" @click.stop="showRefundView">
                    <v-icon left>paid</v-icon>
                    Estornar Transação
                  </v-btn>
                  <v-flex v-if="isRefundedTransactionVisible">
                      <v-textarea label="Razão para o estorno" outlined v-model="refundReason" rows="1" class="mt-3"></v-textarea>
                      <span v-if="refundError" class="error-message">
                              {{ refundError }}
                            </span>
                    <v-layout justify-end class="mt-1">
                      <v-btn color="#27DABC" style="color: white;" class="mt-1" @click="submitRefund" :disabled="!refundReason">
                        Realizar estorno
                      </v-btn>
                      <v-btn color="secondary" style="color: white;" class="mt-1" @click="toggleTransactionView">
                        Cancelar
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>

<script>
import utils from "./shared/Utils"
import i18n from "./shared/Translations"

export default {
  name: 'BankTransactionItem',
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      current_view: 'short',
      transactionCanceled: false,
      isRefundedTransactionVisible: false,
      refundReason: "",
      refundError: ""
    }
  },
  computed: {
    isFromCreditCard() {
      return this.record.source_type == 'CREDIT CARD'
    },
    humanMovementDate() {
      return utils.dbDateToHuman(this.record.movement_date)
    },
    bankAccount() {
      return utils.longAccountName(this.record.bank_account)
    },
    isEstimatedValue() {
      return this.record.estimated_value_until_exchange === true && this.record.exchange_approved === false
    },
    companyName() {
      if (!this.record.scheduled_bank_transaction) return ''
      if (!this.record.scheduled_bank_transaction.company) return ''
      return this.record.scheduled_bank_transaction.company.social_name
    },
    iof_value() {
      return this.l(this.record.iof_value, "BRL")
    },
    fx_value() {
      return this.l(this.record.fx_value, this.fx_value_currency)
    },
    fx_value_currency() {
      if (this.$root.isLocalCurrency(this.record.exchange_currency)) {
        return this.record.exchange_currency
      } else {
        return this.record.currency
      }
    }
  },
  methods: {
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    insertedDate(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[0]
    },
    insertedTime(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[1]
    },
    transactionCanceledDate() {
      return utils.dbDateTimeToHuman(this.record.scheduled_bank_transaction.canceled_at)
    },
    showRefundView() {
      this.isRefundedTransactionVisible = true;
    },
    translate(key) {
    if (!key || !i18n[key]) {
      return "Não foi possível realizar o estorno. Entre em contato com o suporte";
    }
    return i18n[key].pt;
    },
    toggleTransactionView() {
      this.isRefundedTransactionVisible = !this.isRefundedTransactionVisible;
    },
    async submitRefund() {
      const payload = {
        reason: this.refundReason,
      };

      const successCallback = () => {
        this.isRefundedTransactionVisible = false;
        this.refundReason = "";
        this.refundError = "";
        this.$emit("refund-success", this.record);
      };

      const errorCallback = (response) => {
        console.error("Erro ao realizar estorno:", response);
        const errorKey = response.body.error || null;
        const errorMessage = this.translate(errorKey);
        this.refundError = errorMessage;
        this.isRefundedTransactionVisible = true;
      };

      const token = this.$cookies.get("api_token");

      this.$http
        .post(
          this.$root.urls.customer__bank_transactions_refund.replace("ID", this.record.id),
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(successCallback, errorCallback);
    },
  },
  mounted() {
    if(this.record.scheduled_bank_transaction && this.record.scheduled_bank_transaction.status === 'canceled') {
      this.transactionCanceled = true
    };
  }
}
</script>

<style>
.canceled{
    color:#6b2a2a;
  }
  .v-icon.blue_icon {
    color: #37517e;
  }
  .v-icon.grey_icon {
    color: #CCC;
  }
  .error-message {
    color: red;
    font-size: 0.9rem;
    margin-top: 4px;
  }
  .absolute-btn,
  .absolute-btn:hover {
    top: -56px;
    position: absolute;
  }
  .absolute-btn-parent {
    position: relative;
  }
  .hide-if-mobile {
    display: flex;
  }
  @media (max-width: 1260px) {
    .absolute-btn,
    .absolute-btn:hover {
      margin-top: 6px !important;
      top: 0px!important;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/BankTransactionItem.vue